const colddrinks = [
  {
    id: 1,
    name: "Coke/Diet/Seven Up/Fanta",
    price: "£1.50"
  },
  {
    id: 2,
    name: "Sweet Lassi - Plain",
    price: "£2.20"
  },
  {
    id: 3,
    name: "Sweet Lassi - Mango",
    price: "£2.50"
  },
  {
    id: 4,
    name: "Chhash (Buttermilk) - Coriander",
    description: "A popular Indian buttermilk - refreshing yogurt-based drink, churning yogurt with water and then typically seasoned with spices like cumin and ginger.",
    price: "£1.50"
  }
];

export default colddrinks;